import ServiceExec from '@/common/utils/ServiceExec';
import queryString from 'query-string';
import classApi from '@/common/service/apis/ClassApi';
/**
 * 공통 API Service
 * @class CommonSvc
 */

class CommonSvc extends ServiceExec {
  /**
   * 파일 업로드
   * @param file {string} 파일
   */
  fileUpload(params = {}) {
    return this.multiPost('/api/pqas/mct/uploadSignImage', params).then(response => {
      return response.data;
    });
  }

  videoDownload(params = {}) {
    return this.ServiceExec.request({
      method: 'GET',
      url: `/common/download?${queryString.stringify(params)}`,
      responseType: 'blob'
    });
  }

  deviceIntro(params = {}) {
    return this.post('/common/intro', params)
      .then(response => {
        return response.data;
      })
      .catch(error => {
        console.log('deviceIntro error: ', error);
      });
  }
}

export default new CommonSvc();
